import * as React from 'react';
import {Link as RoutedLink} from 'react-router-dom';

import {FlashBanner} from 'shells/flash-banner/flash-banner';
import {Link} from 'shells/link/link';
import {Body} from 'shells/typography/body';

export function SetupChatbotBanner() {
    return (
        <FlashBanner type='warning' hasBorder={true}>
            <div className='flex justify-sb full-width'>
                <Body color='warn'>
                    Complete the 3-step setup process to train your AI chatbot, preview it, and
                    embed it on your website.
                </Body>
                {/* @ts-expect-error */}
                <Link as={RoutedLink} variant='primary' to='/inbox/settings/chat-onboarding'>
                    Let’s do it
                </Link>
            </div>
        </FlashBanner>
    );
}
